"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateFormByMobileApp = void 0;
const phone_display_value_casting_1 = require("./phone-display-value-casting");
const updateFormByMobileApp = (updateFormValue, deviceType, phoneFromMobileApp) => {
    updateFormValue('WhoIssuesPolicy.showSwitcher', true);
    if (deviceType && phoneFromMobileApp) {
        const formattedPhone = (0, phone_display_value_casting_1.phoneDisplayValueCasting)(phoneFromMobileApp)
            .trim()
            .slice(2);
        updateFormValue('WhoIssuesPolicy.showSwitcher', false);
        updateFormValue('WhoIssuesPolicy.client', true);
        updateFormValue('WhoIssuesPolicy.phone', formattedPhone);
    }
};
exports.updateFormByMobileApp = updateFormByMobileApp;
